import '@customerio/cdp-analytics-browser';
import { useCallback } from 'react';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';

const useCustomerIO = () => {
  const { t } = useTranslation();

  const trackEvent = useCallback(
    (eventName: string, eventData: Record<string, any>, successMessage?: string) => {
      try {
        window._cio?.track(eventName, eventData);
        if (successMessage)
          notification.success({
            message: t('success'),
            description: successMessage,
          });
      } catch (error) {
        console.error('ERROR: ', error);
      }
    },
    [],
  );

  const identifyUser = useCallback((userId: string, traits: Record<string, any>) => {
    console.log('[CustomerIO] Trying to identify user...', { _cio: window._cio });

    window._cio?.identify({ id: userId, ...traits });
  }, []);

  return { trackEvent, identifyUser };
};

export default useCustomerIO;
